import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaYoutube, FaLinkedin } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: var(--secondary); /* Light grey */
  color: var(--text);
  padding: 4rem 0 2rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  margin-bottom: 2rem;
`;

const FooterLogo = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--text);
  
  span {
    color: var(--accent-turquoise);
  }
`;

const FooterTagline = styled.p`
  margin-bottom: 1.5rem;
  color: var(--text-light);
`;

const FooterLinksHeading = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: var(--accent-lavender);
  text-align: center;
`;

const FooterLinksList = styled.ul`
  list-style: none;
  padding: 0;
  text-align: center;
`;

const FooterLinkItem = styled.li`
  margin-bottom: 0.5rem;
`;

const FooterLink = styled(Link)`
  color: var(--text-light);
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--accent-turquoise);
  }
`;

const ExternalLink = styled.a`
  color: var(--text-light);
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--accent-turquoise);
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  justify-content: center;
`;

const SocialIcon = styled.a`
  color: var(--text-light);
  font-size: 1.8rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--accent-turquoise);
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 2rem 0;
  border-top: 1px solid var(--grey-border);
  text-align: center;
  color: var(--text-light);
  font-size: 0.9rem;
`;

const ContactInfo = styled.div`
  text-align: center;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterLogo>Passport <span>Creative</span></FooterLogo>
          <FooterTagline>From Paris, we craft smarter marketing, partnerships, and tools for travel brands ready to lead.</FooterTagline>
        </FooterSection>
        
        <FooterSection>
          <FooterLinksHeading>Explore</FooterLinksHeading>
          <FooterLinksList>
            <FooterLinkItem><FooterLink to="/services">Services</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/projects">Projects</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/tools">Tools</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/about">About</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/blog">Blog</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/contact">Contact</FooterLink></FooterLinkItem>
          </FooterLinksList>
        </FooterSection>
        
        <FooterSection>
          <FooterLinksHeading>Travel & Tourism Resources</FooterLinksHeading>
          <FooterLinksList>
            <FooterLinkItem><ExternalLink href="https://shareitinerary.com" target="_blank" rel="noopener noreferrer">Share Itinerary</ExternalLink></FooterLinkItem>
            <FooterLinkItem><ExternalLink href="https://atraversa.com" target="_blank" rel="noopener noreferrer">Atraversa</ExternalLink></FooterLinkItem>
            <FooterLinkItem><ExternalLink href="https://planfamtrips.com" target="_blank" rel="noopener noreferrer">Plan Fam Trips</ExternalLink></FooterLinkItem>
            <FooterLinkItem><ExternalLink href="https://travelmarketingplan.com" target="_blank" rel="noopener noreferrer">Travel Marketing Plan</ExternalLink></FooterLinkItem>
          </FooterLinksList>
        </FooterSection>
        
        <FooterSection>
          <FooterLinksHeading>Connect</FooterLinksHeading>
          <ContactInfo>
            <p>Email: alex@passportcreative.co</p>
            <p>Based in Paris, working globally</p>
            <SocialLinks>
              <SocialIcon href="https://www.youtube.com/@passportcreative" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </SocialIcon>
              <SocialIcon href="https://linkedin.com/company/passportcreative" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </SocialIcon>
            </SocialLinks>
          </ContactInfo>
        </FooterSection>
      </FooterContent>
      
      <FooterBottom>
        <p>&copy; {currentYear} Passport Creative. All rights reserved.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;